import type { FC } from "react";
import {
  Alert,
  Container,
  Flex,
  Section,
  Button,
} from "@/ui";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import {
  TCatLifestyleCardCaloriesSectionProps,
} from "./CatLifestyleCard.config";

export const CatLifestyleCardCaloriesSection: FC<TCatLifestyleCardCaloriesSectionProps> = ({
  calories,
  description,
  alert,
  title,
  editCopy,
  editAriaLabel,
  onEdit,
}) => (
  <Section>
    <Flex gap="4" align="center" justify="between">
      <Container>
        <TextBody color="secondary" size={3}>
          { title }
        </TextBody>
        <TextSubtitle className="mt-1" size={4}>
          { calories }
        </TextSubtitle>
      </Container>
      <Button aria-label={editAriaLabel} onClick={onEdit} variant="tertiary">
        { editCopy }
      </Button>
    </Flex>

    <TextBody className="mt-4" color="secondary" size={2}>
      { description }
    </TextBody>

    { alert ? (
      <Alert asset="circleTick" className="mt-4" variant="reassurace">
        { alert }
      </Alert>
    ) : null }
  </Section>
);
